<template>
	<div class="loginswiper">
		<swiper :options="swiperOption">
			<swiper-slide><img src="../../../static/img/chonglianwang.png" /></swiper-slide>
			<swiper-slide><img src="../../../static/img/chonglianwang.png" /></swiper-slide>
			<swiper-slide><img src="../../../static/img/dp-logo.jpg" /></swiper-slide>
			<swiper-slide>
				<login></login>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
import login from "../login/login";
import { email } from "../../api/index.js";
export default {
    name: "loginswiper",
    data() {
        return {
            loginsuccess: false,
            loginshowflag: true,
            pic: [
                "../../../static/img/dog_default.jpg",
                "../../../static/img/chonglianwang.png",
                "../../../static/img/dp-logo.jpg",
                "../../../static/img/voice.png"
            ],
            swiperOption: {
                pagination: ".swiper-pagination",
                direction: "vertical",
                paginationClickable: true,
                autoplay: false,
                height: window.innerHeight,
                mousewheel: false,
                autoplayDisableOnInteraction: false,
                loop: false,
                coverflow: {
                    rotate: 30,
                    stretch: 10,
                    depth: 60,
                    modifier: 2,
                    slideShadows: true
                }
            }
        };
    },
    components: {
        login: login
    },
    mounted() {},
    methods: {}
};
</script>

<style scoped>
.loginswiper {
    width: 100%;
    font-size: 0;
}
.swiper-container {
    width: 100%;
}
.swiper-slide img {
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/loginswiper.vue